import { render, staticRenderFns } from "./AndOptions.vue?vue&type=template&id=452a524a"
import script from "./AndOptions.vue?vue&type=script&lang=ts"
export * from "./AndOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports